// GTM event types
export const PAGE_VIEW_EVENT = 'page-view';

// Data Layers Names
export const PAGE_METRICS_DATALAYER_NAME = 'pageMetricsDataLayer';
